// extracted by mini-css-extract-plugin
export default {"notification-alert":"NotificationAlert_notification-alert__hxx60"};